import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  InputBase,
  alpha,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import { useAuth } from "../context/AuthContext";
import { useColorMode } from "../context/ThemeContext";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import NotificationBell from "./NotificationBell";

export default function Header({ onMenuClick }) {
  const { user } = useAuth();
  const { mode, toggle } = useColorMode();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{ bgcolor: "background.paper" }}
    >
      <Toolbar sx={{ gap: 1 }}>
        {!isDesktop && (
          <IconButton edge="start" onClick={onMenuClick} sx={{ mr: 1 }}>
            <MenuIcon />
          </IconButton>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
          Welcome, {user?.name}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
            alignItems: "center",
            bgcolor: (t) => alpha(t.palette.text.primary, 0.06),
            borderRadius: 2,
            px: 1.5,
            py: 0.5,
            mr: 1,
            minWidth: 240,
          }}
        >
          <SearchIcon fontSize="small" sx={{ color: "text.secondary", mr: 1 }} />
          <InputBase placeholder="Search…" sx={{ fontSize: 14, flex: 1 }} />
        </Box>

        <IconButton onClick={toggle} aria-label="toggle theme">
          {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>

        <NotificationBell />
      </Toolbar>
    </AppBar>
  );
}
